import React from "react";
import {
  PulseButton,
  PulseButtonTheme,
  PulsePopupContainerSize,
} from "@pulselabs-ai/shared-fe-ui";
import CustomDialog from "../customDialog/CustomDialog";
import "./PulsePopupConfirmation.scss";

interface PulsePopupConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  icon?: React.ReactNode;
  iconColor?: string;
  iconSize?: number;
  title: string;
  description?: string;
  confirmButtonText: string;
  cancelButtonText: string;
  onConfirm: () => void;
  confirmButtonTheme?: PulseButtonTheme;
  cancelButtonTheme?: PulseButtonTheme;
  containerSize?: PulsePopupContainerSize;
}

export const PulsePopupConfirmation: React.FC<PulsePopupConfirmationProps> = ({
  isOpen,
  onClose,
  icon,
  iconColor = "#FF0052",
  iconSize = 36,
  title,
  description,
  confirmButtonText,
  cancelButtonText,
  onConfirm,
  confirmButtonTheme = PulseButtonTheme.TERTIARY_DESTRUCTIVE,
  cancelButtonTheme = PulseButtonTheme.TERTIARY_BLACK,
  containerSize = PulsePopupContainerSize.SMALL,
}) => {
  return (
    <CustomDialog
      isOpen={isOpen}
      onClose={onClose}
      containerSize={containerSize}
      showCloseIcon={false}
      roundedCorners={true}
      isBackgroundClose={false}
    >
      <div className="pulse-popup-confirmation">
        <div className="content-group">
          {icon && (
            <div className="icon">
              {React.cloneElement(icon as React.ReactElement, {
                style: { fontSize: iconSize, color: iconColor },
              })}
            </div>
          )}
          <h3>{title}</h3>
          {description && <p>{description}</p>}
        </div>
        <div className="button-group">
          <PulseButton theme={cancelButtonTheme} onClick={onClose}>
            {cancelButtonText}
          </PulseButton>
          <PulseButton
            theme={confirmButtonTheme}
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmButtonText}
          </PulseButton>
        </div>
      </div>
    </CustomDialog>
  );
};
